import {ValueObject} from '@s-ui/domain'

export default class SearchesListValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Array} data.items
   */
}
